export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();
  const appId = config.public?.scripts?.intercomAppId?.id;
  if (!appId) {
    console.warn("[Intercom] No Intercom App ID found in runtime config.");
    return;
  }
  const { load, onLoaded } = useScriptIntercom({ app_id: appId });
  const user = useSanctumUser();
  const route = useRoute();
  load();
  watch(user, (newUser) => {
    if (newUser?.id && typeof window !== "undefined" && window.Intercom) {
      const payload = {
        app_id: appId,
        user_id: newUser.id,
        name: newUser.name,
        email: newUser.email,
      };
      window.Intercom("shutdown");
      window.Intercom("update", payload);
    }
    if (!newUser && typeof window !== "undefined" && window.Intercom) {
      window.Intercom("shutdown");
      window.Intercom("boot", { app_id: appId });
    }
  });
  onLoaded(async () => {
    if (user.value?.id && typeof window !== "undefined" && window.Intercom) {
      const payload = {
        app_id: appId,
        ...(user.value.id && { user_id: user.value.id }),
        ...(user.value.name && { name: user.value.name }),
        ...(user.value.email && { email: user.value.email }),
      };
      window.Intercom("shutdown");
      window.Intercom("update", payload);
    } else {
      console.log("[Intercom] - Guest Mode");
    }
    nextTick(() => {
      if (route?.query?.openIntercom === "true") {
        window.Intercom("show");
      }
    });
  });
});
